export const footerData = {
  footer_title: {
    title_ua: "Є питання? \nЗв'яжіться з нами!",
    title_ru: 'Есть вопросы? \nСвяжитесь с нами!',
  },
  copy: {
    title_ua: '2021 "Шо? School" © Всі права захищені.',
    title_ru: '2021 "Шо? School" © Все права защищены.',
  },
  copy_links: [
    {
      title_ua: 'Конфіденційність',
      title_ru: 'Конфиденциальность',
      link: '/privacy-policy/',
    },
    {
      title_ua: 'Угода Користувача',
      title_ru: 'Пользовательское соглашение',
      link: '/terms-of-use/',
    },
  ],
};
